<template>
  <div class="leaderList">
    <!-- 头部信息 -->
    <div class="header_box">
      <!-- 头部搜索框 -->
      <!-- <div class="search">
        <input type="text" class="search_key" :placeholder="hold" v-model="searchkey" />
        <span class="search_btn" @click="startSearch">查询</span>
        <img src="../../../../../assets/image/search.png" class="search_img" />
      </div> -->
      <!-- 筛选功能 -->
      <!-- <div class="search_query">
        <div class="item" @click="showCity">
          <span class="city">{{md.cityPickerValue}}</span>
          <img src="../../../../../assets/image/jiantou.png" class="jian" />
        </div>
        <div class="item" @click="showType">
          <span class="city">{{md.typePickerValue}}</span>
          <img src="../../../../../assets/image/jiantou.png" class="jian" />
        </div>
        <div class="item" @click="showTime">
          <span class="city">{{md.datePickerValue}}</span>
          <img src="../../../../../assets/image/jiantou.png" class="jian" />
        </div>
      </div> -->
    </div>
    <van-list
      ref="vanList"
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      :immediate-check="false"
      @load="onLoad"
      class="wrapper"
    >
      <div class="reject" v-for="(item,index) in proList" :key="index" @click="goDetail(item)">
        <div class="reject_item">
            <div class="item_content">
                <div class="title">
                    <p class="title_text">{{item.defendant_name }}</p>
                    <p
                    class="title_tag1"
                    :class="sstt[item.urgency_degree == '' ? '': Number(item.urgency_degree-7)]"
                    >{{sttText[item.urgency_degree == '' ? '': Number(item.urgency_degree-7)]}}</p>
                </div>
                <div class="info">
                    <span>投诉人:</span>
                    <span>{{item.complain_name}}</span>
                </div>
                <div class="info">
                    <span>投诉时间:</span>
                    <span>{{item.complain_time|filt()}}</span>
                </div>
                <div class="info">
                    <span>处理时长:</span>
                    <span>{{item.handle_time|filt3()}}</span>
                    <!-- <span class="info_line"></span>
                    <span>{{item.handle_time_limit|filt4()}}</span> -->
                </div>
                <div class="wrappers">
                    <p>所属区域:</p>
                    <p>{{item.belong_mechanism_name}}</p>
                </div>
                <div class="info">
                    <span>投诉单号:</span>
                    <span>{{item.main_complain_number}}</span>
                </div>
            </div>
            <div class="line"></div>
            <div class="status">
                <p>{{item.statue_name}}</p>
                    <p>
                        <span>查看详情</span>
                        <span>
                            <img src="../../../../../assets/image/right.png" alt="">
                        </span>
                    </p>
            </div>
        </div>
      </div>
    </van-list>
    <isNoInfo :isNolist="isNolist"></isNoInfo>
    <!-- <common-picker ref="commonPicker1" :typeList="typeList1" :cols="cols1" @getTypeValue="getCityValue"></common-picker>
    <common-picker ref="commonPicker2" :typeList="typeList2" :cols="chnnerCol" @getTypeValue="getTypeValue"></common-picker>
    <common-picker ref="commonPicker3" :typeList="typeList3" :cols="cols3" @getTypeValue="getValue" :isShowAbountButton="true"  @showRangTime="showRangTime"></common-picker>
    <rang-time ref="rangsTime" @closeRangTime="closeRangTime" v-if="ishowRangeTime"></rang-time> -->
  </div>
</template>
<script>
    import api from '../../../../../service/modules/complaint';
    // import apiAssess from '../../../../../service/modules/common.js';
    import util from '../../../../../utils/common';
    import moment from 'moment';
    // import { formateYear, timeType, channer, timeType1 } from '../../../../../utils/configJson';
    // import commonPicker from '../../../../../components/base/commonPicker';
    // import rangTime from '../../../../../components/rangTime.vue';
    import isNoInfo from '../../../../../components/isNoInfo.vue';

    export default {
        components: {
            // commonPicker,
            // rangTime,
            isNoInfo
        },
        data () {
            return {
                // md: {
                //     datePickerValue: '筛选时间',
                //     typePickerValue: '投诉渠道',
                //     cityPickerValue: this.$route.query.fullAdress,
                //     cityCode: '',
                //     typeCode: ''
                // },
                sstt: ['ss1', 'ss2', 'ss3'],
                sttText: ['一般', '较重', '严重'],
                hold: '投诉单号/投诉人姓名/被投诉对象名称',
                // searchkey: '', // 搜索的ke值
                finished: false,
                finishedText: '没有更多',
                loading: true,
                proList: [], // 列表
                pageIndex: '0',
                // startTime: '',
                chnnerCol: 1,
                userId: '', // 用户id
                // endTime: '',
                ishowRangeTime: false,
                typeList: [],
                scrollY: 0,
                timer: null,
                pickerValue: '',
                isPicker: false,
                currentDate: new Date(),
                pageSize: '10',
                isNolist: false, // 没有内容的状态
                message: '加载中...',
                // cityList: [],
                // typeList1: timeType,
                // cols1: 2,
                // typeList2: channer,
                // cols2: 1,
                // typeList3: timeType1,
                // cols3: 3,
                listType: '', // 列表类型   this.$router.query.type
                areaId: '',
                // quarter: this.$route.query.quarter,
                queryObj: {},
                list: {}
                // year: this.$route.query.year
            };
        },
        created () {
            this.listType = this.$route.query.type;
            this.areaId = this.$route.query.areaOne;
            // if (this.areaId) {
            //     this.getAllCity();
            // }
            // if (this.quarter !== undefined && this.year !== undefined) {
            //     this.md.datePickerValue = this.year + this.typeList3[0][0].children[1].children[this.quarter].text;
            //     this.startTime = this.year + '-' + this.typeList3[0][0].children[1].children[this.quarter].value1 + ' ' + '00:00:00';
            //     this.endTime = this.year + '-' + this.typeList3[0][0].children[1].children[this.quarter].value2 + ' ' + '23:59:59';
            //     this.getList();
            // } else {
            this.getList();
            // }
        },
        mounted () {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            // showRangTime () {
            //     setTimeout(() => {
            //         this.ishowRangeTime = true;
            //     }, 500)
            // },
            // closeRangTime (value) {
            //     console.log('value', value)
            //     if (value) {
            //         this.startTime = value[0] + ' ' + '00:00:00';
            //         this.endTime = value[1] + ' ' + '23:59:59';
            //         this.md.datePickerValue = value[2];
            //         this.getList();
            //         this.ishowRangeTime = false;
            //     } else {
            //         this.ishowRangeTime = false;
            //     }
            // },
            goDetail (value) {
                this.$router.push({
                    name: 'assessDetails',
                    params: {
                        item: value
                    }
                });
                util.setJsonLocal('item', value);
                this.$store.commit('complaint/getItemList', value);
                this.$store.commit('complaint/setCheckList', false);
            },
            // showCity () {
            //     this.$refs.commonPicker1.showPicker();
            // },
            // showType () {
            //     this.$refs.commonPicker2.showPicker();
            // },
            // showTime () {
            //     this.$refs.commonPicker3.showPicker();
            // },
            // openTime1 () {
            //     setTimeout(() => {
            //         this.ishowRangeTime = true;
            //     }, 500);
            // },
            // getValue (value) {
            //     console.log('values111111111111111', value)
            //     if (value[1].key === 'year') {
            //         this.md.datePickerValue = value[0].value + '年';
            //         this.startTime = value[0].value + '-' + value[1].value1 + ' ' + '00:00:00';
            //         this.endTime = value[0].value + '-' + value[1].value2 + ' ' + '23:59:59';
            //     } else if (value[1].key === 'quarter') {
            //         this.md.datePickerValue = value[0].value + value[2].text;
            //         this.startTime = value[0].value + '-' + value[2].value1 + ' ' + '00:00:00';
            //         this.endTime = value[0].value + '-' + value[2].value2 + ' ' + '23:59:59';
            //     } else if (value[1].key === 'moutn') {
            //         this.md.datePickerValue = value[0].value + '年' + value[2].value1 + '月';
            //         const d = new Date(value[0].value, value[2].value1, 0)// 获取当月的天数
            //         this.startTime = value[0].value + '-' + value[2].value1 + '-01' + ' ' + '00:00:00';
            //         this.endTime = value[0].value + '-' + value[2].value1 + '-' + d.getDate() + ' ' + '23:59:59';
            //     }
            //     this.proList = [];
            //     this.getList();
            // },
            // getTypeValue (value) {
            //     this.md.typeCode = value[0].value;
            //     this.md.typePickerValue = value[0].text;
            //     this.getList();
            // },
            // getCityValue (value) {
            //     console.log(66, value);
            //     if (value.length > 1) {
            //         this.md.cityPickerValue = value[0].label + '-' + value[1].label;
            //         this.areaId = value[1].areaId;
            //     } else {
            //         this.md.cityPickerValue = value[0].label;
            //         this.areaId = value[0].areaId;
            //     }
            //     this.getList();
            // },
            // getTimeValue (value) {
            //     this.md.datePickerValue = value;
            // },
            // 查询
            // startSearch () {
            //     //
            //     if (this.searchkey.trim().length === 0) {
            //         this.startTime = '';
            //         this.endTime = '';
            //         this.md.cityCode = '';
            //         this.md.typeCode = '';
            //         this.pageIndex = '1';
            //         this.searchkey = '';
            //         this.getList();
            //     } else {
            //         // 调去搜索的接口,重置所有的搜索条件
            //         this.md.typeCode = '';
            //         this.pageIndex = '1';
            //         this.getList();
            //     }
            // },
            // 查询列表
            getList () {
                this.proList = [];
                this.pageIndex = 1;
                const data = {
                    curPage: this.pageIndex,
                    pageSize: 10,
                    type: 'queryList',
                    listType: this.listType,
                    place: this.areaId,
                    startDate: this.startTime,
                    endDate: this.endTime
                }
                api.dylxsList(data).then((res) => {
                    this.loading = false; // 加载参数
                    if (res.data.list.length > 0) { // 有数据
                        this.proList = res.data.list;
                        if (res.data.list.length === res.data.totalSize) { // 已加载完了
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                        this.isNolist = false;
                    } else {
                        this.finished = true;
                        this.loading = false;
                        this.isNolist = true;
                        this.finishedText = '';
                    }
                    console.log('data', this.loading);
                })
            },
            // onload加载更多
            getMore () {
                console.log('1111111111111111111111111')
                let city;
                let time;
                if (this.md.cityPickerValue === '州市-县区') {
                    city = '';
                } else {
                    city = this.md.cityPickerValue;
                }
                const data = {
                    curPage: this.pageIndex,
                    pageSize: 10,
                    type: 'queryList',
                    listType: this.listType,
                    place: this.areaId,
                    startDate: this.startTime,
                    endDate: this.endTime
                }
                api.dylxsList(data).then((res) => {
                    if (res.data.list.length > 0) { // 有数据
                        this.proList = this.proList.concat(res.data.list);
                        if (this.proList.length === res.data.totalSize) {
                            console.log('111111111111111111111111122222')
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                    }
                })
            },
            // getAllCity () {
            //     // 获取所有的市
            //     console.log(345, this.areaId);
            //     apiAssess.getsubnodebyparenttxid({ area: this.areaId }).then(res => {
            //         const address = res.data.list;
            //         var fullAdress = this.$route.query.fullAdress;
            //         // var fullAdress = '云南省';
            //         this.areaId = this.$route.query.areaOne;
            //         // this.areaId = 34;
            //         var city = [
            //             { 'value': '',
            //               'label': fullAdress,
            //               'children': [
            //                   { 'areaId': this.areaId,
            //                     'label': '全部',
            //                     'children': [] }
            //               ] }
            //         ];
            //         if (address[0].F_TX_TYPE === '2' && address[0].name !== '--') {
            //             // 省级权限
            //             for (var i = 0; i < address.length; i++) {
            //                 this.cols = 2;
            //                 var obj = {
            //                     areaId: address[i].areaId,
            //                     value: address[i].code,
            //                     label: address[i].name,
            //                     children: []
            //                 };
            //                 if (address[i].children) {
            //                     address[i].children.map((item, index) => {
            //                         obj.children.push({
            //                             areaId: item.areaId,
            //                             value: item.code,
            //                             label: item.name,
            //                             children: []
            //                         });
            //                     });
            //                 }
            //                 city.push(obj);
            //             }
            //         } else if (address[0].F_TX_TYPE === '3' && address.length !== 1) {
            //             // 市级权限
            //             this.cols1 = 2;
            //             for (var i = 0; i < address.length; i++) {
            //                 var obj = {
            //                     areaId: address[i].areaId,
            //                     value: address[i].code,
            //                     label: address[i].name,
            //                     children: []
            //                 };
            //                 if (address[i].children) {
            //                     address[i].children.map((item, index) => {
            //                         obj.children.push({
            //                             areaId: item.areaId,
            //                             value: item.code,
            //                             label: item.name,
            //                             children: []
            //                         });
            //                     });
            //                 }
            //                 city[0].children.push(obj);
            //             };
            //         } else {
            //             // 区县角色n
            //             this.cols1 = 1;
            //             var obj = {
            //                 areaId: address[0].areaId,
            //                 value: address[0].code,
            //                 label: address[0].name,
            //                 children: []
            //             };
            //             city = [];
            //             city.push(obj);
            //         }
            //         this.typeList1 = [];
            //         this.typeList1.push(city);
            //         setTimeout(() => {
            //             this.$refs.commonPicker1._initFresh();
            //         }, 50);
            //     });
            // },
            onLoad () {
                this.pageIndex++;
                this.getMore();
            }
        },
        filters: {
            filt (value) {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
            },
            // filt1 (value) {
            //     var config = util.getJsonLocal('configList').PRODUCT_TYPE;
            //     let name = '';
            //     config.map((item, index) => {
            //         if (item.code === value) {
            //             name = item.name;
            //         }
            //     });
            //     return name;
            // },
            // filt2 (value) {
            //     var config = util.getJsonLocal('configList').WORK_ORDER_FLOW;
            //     let name = '';
            //     config.map((item, index) => {
            //         if (item.code === value) {
            //             name = item.name;
            //         }
            //     });
            //     return name;
            // },
            // 时长计算
            filt3 (str) {
                let duration = str;

                let zero = function (times) {
                    return times;
                };
                let hour = zero(Math.floor(duration / 3600));
                let minutes = zero(Math.ceil((duration / 60) % 60));
                let times = '';
                if (hour > 0) {
                    times += hour + '小时';
                }
                times += minutes + '分钟';
                return times;
            }
            // 计算时限
            // filt4 (str) {
            //     let duration = str;
            //     let zero = function (times) {
            //         return times;
            //     };
            //     let hour = zero(Math.floor(duration / 3600));
            //     let minutes = zero(Math.ceil((duration / 60) % 60));
            //     let times = '';
            //     if (hour > 0) {
            //         times += hour + 'h';
            //     }
            //     if (minutes > 0) {
            //         times += minutes + 'm';
            //     }
            //     return times;
            // }
        }
    };
</script>
<style scoped lang="less">
.leaderList {
  width: 100%;
  height: 100%;
  background-color: #fbfbfb;
  // .header_box {
  //   width: 100%;
  //   position: fixed;
  //   left: 0;
  //   top: 0;
  //   z-index: 2;
  //   background-color: #fff;
  //   .search {
  //     width: 100%;
  //     position: relative;
  //     margin-top: 10px;
  //     .search_key {
  //       width: 297px;
  //       height: 36px;
  //       background: #f8f8f8;
  //       border-radius: 18px;
  //       margin-left: 15px;
  //       font-size: 13px !important;
  //       padding-left: 39px;
  //       box-sizing: border-box;
  //       border: 0;
  //       outline: none;
  //       line-height: 36px;
  //     }
  //     .search_btn {
  //       font-size: 14px;
  //       margin-left: 16px;
  //     }
  //     .search_img {
  //       width: 15px;
  //       height: 14px;
  //       position: absolute;
  //       left: 30px;
  //       top: 11px;
  //     }
  //   }
  //   .search_query {
  //     width: 100%;
  //     height: 42px;
  //     display: flex;
  //     display: -webkit-flex;
  //     flex-direction: row;
  //     -webkit-flex-direction: row;
  //     border-bottom: 1px solid #eee;
  //     .item {
  //       flex: 1;
  //       text-align: center;
  //       line-height: 42px;
  //       .city {
  //         display: inline-block;
  //         vertical-align: middle;
  //         font-size: 12px;
  //         color: #666;
  //         max-width: 110px;
  //         overflow: hidden;
  //         white-space: nowrap;
  //         text-overflow: ellipsis;
  //       }
  //       .jian {
  //         width: 6px;
  //         height: 4px;
  //         display: inline-block;
  //         vertical-align: middle;
  //       }
  //     }
  //   }
  // }
  .wrapper {
    width: 100%;
    padding-top:20px;
    .reject {
      width: 100%;
      padding-bottom: 16px;
      .reject_item {
        margin:0 12px;
        box-sizing: border-box;
        background-color: #fff;
        box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        .item_content {
            padding:16px;
            .info {
                margin-top: 12px;
                span {
                    font-size: 14px;
                    color: #777;
                }
                span:nth-child(1) {
                    display: inline-block;
                    width: 65px;
                    font-size: 14px;
                    color: #777;
                }
                span:nth-child(2) {
                    display: inline-block;
                    font-size: 14px;
                    color: #777;
                }
                .info_line {
                    content:'';
                    display: inline-block;
                    background: #666666;
                    margin: -8px 5px;
                    width:1px;
                    height: 16px;
                    -webkit-transform:scaleY(0.5);
                    transform:scaleY(0.5);
                    -webkit-transform-origin: 0 0;
                    transform-origin: 0 0;
                }
            }
            .wrappers {
                margin-top: 12px;
                display: flex;
                p {
                    font-size: 14px;
                    color: #777;
                }
                p:nth-child(1) {
                    width: 65px;
                    font-size: 14px;
                    color: #777;
                    line-height: 16px;
                }
                p:nth-child(2) {
                    font-size: 14px;
                    color: #777;
                    width: 79%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    line-height: 16px;
                }
                .info_line {
                    content:'';
                    display: inline-block;
                    background: #666666;
                    margin: -8px 5px;
                    width:1px;
                    height: 16px;
                    -webkit-transform:scaleY(0.5);
                    transform:scaleY(0.5);
                    -webkit-transform-origin: 0 0;
                    transform-origin: 0 0;
                }
            }
        }
        .line {
          width: 100%;
          height: 1px;
          margin-top: 2px;
          position: relative;
          border: none;
        }
        .line:after {
          content:'';
          position:absolute;
          bottom: 0;
          left: 0;
          background: #eeeeee;
          width:100%;
          height: 1px;
          -webkit-transform:scaleY(0.5);
          transform:scaleY(0.5);
          -webkit-transform-origin: 0 0;
          transform-origin: 0 0;
        }
        .status {
            width: 100%;
            padding: 20px 16px;
            font-size: 14px;
            color: #333;
            display: flex;
            justify-content: space-between;
            p:nth-child(2) {
                display: flex;
                align-items: center;
                span {
                    color: #999999;
                    font-size: 12px;
                }
            }
            p>span>img {
                width: 4px;
                height: 7px;
                margin-left: 4px;
                margin-top:-3px;
            }
        }
      }
      .title {
        display: flex;
        justify-content: space-between;
        .title_text {
          font-size: 16px;
          font-weight: 700;
          color: #2a2a2a;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          line-height: 20px;

        }
        .title_tag {
          width: 36px;
          height: 18px;
          font-size: 10px;
          color: #ffffff;
          border-radius: 9px;
          text-align: center;
          line-height: 18px;
        }
        .ss1 {
          background: #118bf5;
        }
        .ss2 {
          background: #ffa509;
        }
        .ss3 {
          background: #f75c32;
        }
      }
      .space {
        width: 100%;
        height: 4px;
        background-color: #eee;
      }
    }
  }

}
</style>
